import React from 'react';
import MarkdownRendererToPdf from '../markdown-renderer/MarkdownRendererToPdf';

interface DocumentPDFRendererProps {
  sections: { id: string; title: string; content: string }[];
  headerTemplate?: string;
  footerTemplate?: string;
  title?: string;
  styleSettings?: {
    fontFamily?: string;
    fontSize?: string;
    lineSpacing?: string;
    marginTop?: string;
    marginBottom?: string;
    marginLeft?: string;
    marginRight?: string;
    pageSize?: string;
    orientation?: string;
  };
  resources?: { id: string; name: string; type: string; url?: string }[];
  enableMermaidPrint?: boolean; // Add flag to enable mermaid in print mode
}

const DocumentPDFRenderer: React.FC<DocumentPDFRendererProps> = React.memo(({
  sections,
  headerTemplate,
  footerTemplate,
  title,
  styleSettings,
  enableMermaidPrint = true,
  // resources - keeping for interface compatibility but not used in new implementation
}) => {// Combine all sections into a single markdown document (memoized to prevent recalculation)
  const combinedMarkdown = React.useMemo(() => {
    return sections
      .map(section => {
        // Don't add section titles as they are metadata - just use the content
        return section.content;
      })
      .join('\n\n---\n\n');
  }, [sections]);
  return (
    <MarkdownRendererToPdf
      markdown={combinedMarkdown}
      styleSettings={styleSettings}
      title={title}
      headerTemplate={headerTemplate}
      footerTemplate={footerTemplate}
      disableMermaid={!enableMermaidPrint} // Enable/disable Mermaid based on flag
    />
  );
});

export default DocumentPDFRenderer;
